import { createSlice } from "@reduxjs/toolkit";

import {
  getVirtualSpaces,
  updateInstance
} from "./actions"
import {
  getCustomerId,
  openModal,
  closeModal
} from "../actions"

const initialState = {
  loadedFirstTime: false,
  loading: false,
  instancesObtained: false,
  virtualSpaces: [],
  userObtained: false,
  userEmail: "",
  modalOn: false
};

const virtualSpacesSlice = createSlice({
  name: "virtualSpaces",
  initialState: initialState,
  reducers: {
    resetVirtualSpaces: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(openModal, (state)=>{
      state.modalOn = true;
    });
    builder.addCase(closeModal, (state) => {
      state.modalOn =false;
    });
    builder.addCase(getVirtualSpaces.fulfilled, (state, action)=>{
      state.instancesObtained = true;
      state.loadedFirstTime = state.userObtained? true:false;
      state.virtualSpaces = action.payload.success ? action.payload.data : [];
    });
    builder.addCase(getVirtualSpaces.pending, (action) => {});
    builder.addCase(getVirtualSpaces.rejected, (action) => {});

    builder.addCase(getCustomerId.fulfilled, (state, action) => {
      state.userObtained = true;
      state.loadedFirstTime = state.instancesObtained ? true : false
      state.userEmail = action.payload.success ? action.payload.data.customer.email : "";
    });
    builder.addCase(getCustomerId.pending, (state) => { });
    builder.addCase(getCustomerId.rejected, (state) => { });

    builder.addCase(updateInstance.fulfilled, (state, action) => {
      state.loading = false;
      state.modalOn = action.payload.success ? false : true;
    });
    builder.addCase(updateInstance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateInstance.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { resetVirtualSpaces } = virtualSpacesSlice.actions;
export default virtualSpacesSlice.reducer;